import {
  addResourceUrl,
  getResourceListByDomainId,
  validateResourceFileByFileName,
  getFilesByResourceId,
  getAllResources,
  addResourceColumnsUrl,
  getResourceColumnsUrl,
  getResourceDetailById,
  getResourceColumnsDetailById,
  updateResourceById,
  updateResourceColumnById,
  getResourceColumnsUrlByDomain,
  getResourcesByIds,
  validateResource,
  cloneResourceUrl,
  cloneResourceColumnUrl,
  reactivateResourceColumnUrl,
  getResourceBackupUrl,
  getResourceColumnBackupUrl,
  validateImportedResourceUrl,
  validateImportedResourceColumnDetailUrl,
  getResourceResultByResourceIdUrl,
  getResourceColumnsByIds,
  autoGenerateDataTypesUrl,
  getValidationsErrorsListByResultIdUrl,
  getValidationsDuplicateErrorsListByResultIdUrl,
  getValidationsCrossFieldsListByResultIdUrl,
  getValidationsNullKeysListByResultIdUrl,
  getValidationsErrorsListByResultIdUrlWithoutIssue,
  getValidationsDuplicateErrorsListByResultIdUrlWithoutIssue,
  getValidationsNullKeysListByResultIdUrlWithoutIssue,
  validateResourceReRun,
  deleteResourceValidationbyIdUrl,
  getValidateResourceReRun,
  backgroundValidateResource,
  backgroundValidateResourceReRun,
  abortResourceValidationbyIdUrl,
  getResourceUsedVariablesUrl,
  getValidationExecutionJobStatusUrl,
  resourcesAuthTagUrl,
  validateRequestEngineUrl,
  validateRequestUrl,
  detectSensitiveColumnsUrl,
  getValidationsParamsUrl,
} from "./constants";
import {
  IGetResourceColumns,
  IGetResourceFilesList,
  IGetResourceProp,
} from "../types/resource";
import base from "../middlewares/interceptors";
import { sanitizeQueryParamValue } from "../utils/rerunQueryParams";

export const getResourceList = async ({
  currentDomainId,
  isScoreConfigAssociated,
}: IGetResourceProp) => {
  try {
    let requestUrl = `${getResourceListByDomainId}/${currentDomainId}/resources`;
    if (isScoreConfigAssociated !== undefined) {
      requestUrl += `?is_score_config_associated=${isScoreConfigAssociated}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addResource = async (reqBody: any) => {
  try {
    const response = await base.post(addResourceUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const addResourceColumns = async (reqBody: any, reqParam?: any) => {
  try {
    const url = `${addResourceColumnsUrl}${
      reqParam ? `?need_domain_creation=${encodeURIComponent(reqParam)}` : ""
    }`;
    const response = await base.post(url, reqBody);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResourceFilesList = async ({
  currentResourceId,
}: IGetResourceFilesList) => {
  try {
    const response = await base.get(
      `${getFilesByResourceId}/${currentResourceId}/files`,
    );
    return response.data;
  } catch (error) {}
};

export const validateResourceDataFile = async (reqBody: any) => {
  try {
    const fileApiUrl = `${validateResourceFileByFileName}/${reqBody.resourceId}?file_name=${reqBody.fileName}`;
    const response = await base.post(fileApiUrl, { data: "" });
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getAllResourceList = async () => {
  try {
    const response = await base.get(getAllResources);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResourceColumnsList = async ({
  currentDomainId,
}: IGetResourceProp) => {
  try {
    const response = await base.get(`${getResourceColumnsUrl}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResourceDetail = async ({
  currentResourceId,
}: IGetResourceFilesList) => {
  try {
    const response = await base.get(
      `${getResourceDetailById}/${currentResourceId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResourceColumnsDetail = async ({
  resourceColumnDetailId,
}: IGetResourceColumns) => {
  try {
    const url = `${getResourceColumnsDetailById}/${resourceColumnDetailId}`;
    const response = await base.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getResourceColumnsDetailWithLoading = async ({
  resourceColumnDetailId,
  setIsLoading,
}: any) => {
  setIsLoading(true);
  try {
    const response = await base.get(
      `${getResourceColumnsDetailById}/${resourceColumnDetailId}`,
    );

    return response.data;
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoading(false);
  }
};

export const detectSensitiveColumns = async ({
  resourceColumnDetailId,
}: {
  resourceColumnDetailId: number;
}) => {
  try {
    const response = await base.get(
      `${detectSensitiveColumnsUrl}/${resourceColumnDetailId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateResource = async ({ currentResourceId, payload }: any) => {
  try {
    // Extract comment from resource to use as query parameter
    const comment = payload?.resource?.comment?.trim();

    // Remove comment from the payload body
    const { resource, ...restPayload } = payload;
    const { comment: _, ...resourceWithoutComment } = resource || {};

    const payloadWithoutComment = {
      ...restPayload,
      resource: resourceWithoutComment,
    };

    // Build request URL with comment as query parameter if present
    const requestUrl = comment
      ? `${updateResourceById}/${currentResourceId}?comment=${encodeURIComponent(
          comment,
        )}`
      : `${updateResourceById}/${currentResourceId}`;

    const response = await base.put(requestUrl, payloadWithoutComment);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateResourceColumn = async ({
  resourceColumnId,
  payload,
}: any) => {
  try {
    // Extract comment from resource_column_details to use as query parameter
    const comment = payload?.resource_column_details?.comment?.trim();

    // Remove comment from the payload body
    const { resource_column_details, ...restPayload } = payload;
    const { comment: _, ...resourceColumnDetailsWithoutComment } =
      resource_column_details || {};

    const payloadWithoutComment = {
      ...restPayload,
      resource_column_details: resourceColumnDetailsWithoutComment,
    };

    // Build request URL with comment as query parameter if present
    const requestUrl = comment
      ? `${updateResourceColumnById}/${resourceColumnId}?comment=${encodeURIComponent(
          comment,
        )}`
      : `${updateResourceColumnById}/${resourceColumnId}`;

    const response = await base.put(requestUrl, payloadWithoutComment);

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteResource = async (currentResourceId: any) => {
  try {
    const response = await base.delete(
      `${updateResourceById}/${currentResourceId}`,
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

/**
 * Reactivate resource
 * @param resourceId - The ID of the resource to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateResource = async (resourceId: string | number) => {
  try {
    const response = await base.put(
      `${updateResourceById}/${resourceId}/reactivate`,
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating resource:", error);
    throw error;
  }
};

export const getResourceColumnsListByDomainId = async ({
  currentDomainId,
}: IGetResourceProp) => {
  try {
    const response = await base.get(
      `${getResourceColumnsUrlByDomain}/${currentDomainId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResourcesByMultipleIds = async (resourceIds: any) => {
  try {
    const resourceIdsQueryParam = resourceIds.join(",");
    const apiUrl = `${getResourcesByIds}?resource_filter_ids=${resourceIdsQueryParam}`;
    const response = await base.get(`${apiUrl}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getResourceColumnsByMultipleIds = async (resourceColIds: any) => {
  try {
    const resourceColIdsQueryParam = resourceColIds.join(",");
    const apiUrl = `${getResourceColumnsByIds}?resource_column_filter_ids=${resourceColIdsQueryParam}`;
    const response = await base.get(`${apiUrl}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
// const buildQueryString = (params: any) => {
//   return Object.keys(params)
//     .filter(
//       (key) =>
//         key !== "validation_severity_level" &&
//         key !== "run_instance" &&
//         key !== "skip_validation"
//     )
//     .map(
//       (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
//     )
//     .join("&");
// };

export const ResourceValidation = async (reqBody: any) => {
  try {
    // const queryString = buildQueryString(runParameters);
    const response = await base.post(`${validateResource}`, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const ReRunResourceValidation = async (reqBody: any) => {
  try {
    const response = await base.post(`${validateResourceReRun}`, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const backgroundResourceValidation = async (reqBody: any) => {
  try {
    // const queryString = buildQueryString(runParameters);
    const response = await base.post(`${backgroundValidateResource}`, reqBody);
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const backgroundReRunResourceValidation = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${backgroundValidateResourceReRun}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return Promise.reject(error);
  }
};
export const getResourcePaginatedList = async ({
  currentDomainId,
  page,
  pSize,
  searchTerm,
  system_id,
  isActive = "true",
  signal,
}: IGetResourceProp) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    // Build base URL with required parameters
    let requestUrl = `${getAllResources}/all/pages?page=${pageN}&size=${pageS}`;

    // Conditionally add is_active parameter only when it's "true" or "false" (not "all")
    if (isActive && isActive !== "all") {
      requestUrl += `&is_active=${isActive}`;
    }

    // Conditionally add domain_id parameter only when a domain is selected
    if (currentDomainId && currentDomainId !== 0) {
      requestUrl += `&domain_id=${currentDomainId}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      requestUrl += `&resource_name=${encodeURIComponent(searchTerm.trim())}`;
    }

    // Add system_id parameter if provided
    if (system_id && system_id !== 0) {
      requestUrl += `&system_id=${system_id}`;
    }

    const response = await base.get(requestUrl, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getResourceColumnsPaginatedList = async ({
  currentDomainId,
  page,
  pSize,
}: IGetResourceProp) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    let requestUrl = `${getResourceColumnsUrl}/all/pages?page=${pageN}&size=${pageS}`;
    if (currentDomainId && currentDomainId !== 0) {
      requestUrl = `${getResourceColumnsUrl}/all/pages?domain_id=${currentDomainId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getResourceColumnsPaginatedListByDomainId = async ({
  currentDomainId,
  page,
  pSize,
  searchTerm,
  isActive = "true",
  signal,
}: IGetResourceProp) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    // Build base URL with required parameters
    let requestUrl = `${getResourceColumnsUrl}/all/pages?page=${pageN}&size=${pageS}`;

    // Conditionally add is_active parameter only when it's "true" or "false" (not "all")
    if (isActive && isActive !== "all") {
      requestUrl += `&is_active=${isActive}`;
    }

    // Conditionally add domain_id parameter only when a domain is selected
    if (currentDomainId && currentDomainId !== 0) {
      requestUrl += `&domain_id=${currentDomainId}`;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      requestUrl += `&name=${encodeURIComponent(searchTerm.trim())}`;
    }

    const response = await base.get(requestUrl, {
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteResourceColumn = async (currentResourceId: any) => {
  try {
    const response = await base.delete(
      `${updateResourceColumnById}/${currentResourceId}`,
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

/**
 * Reactivate resource column
 * @param resourceColumnId - The ID of the resource column to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateResourceColumn = async (
  resourceColumnId: string | number,
) => {
  try {
    const response = await base.put(
      `${reactivateResourceColumnUrl}/${resourceColumnId}/reactivate`,
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating resource column:", error);
    throw error;
  }
};

export const cloneResource = async (reqBody: any, isExisting?: any) => {
  try {
    const response = await base.post(
      `${cloneResourceUrl}/${reqBody.resource_id}${
        isExisting === false
          ? "?use_existing_resource_column_details=false"
          : ""
      }`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
export const autoGenerateDataTypes = async (fileFormData: any) => {
  try {
    base.interceptors.request.use(
      (config: { data: any; headers: { [x: string]: any } }) => {
        if (config.data instanceof FormData) {
          delete config.headers["Content-Type"];
        }
        return config;
      },
    );
    const token = localStorage.getItem("token");
    const response = await base.post(
      `${autoGenerateDataTypesUrl}`,
      fileFormData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    if (base.isCancel(error)) {
      throw new Error("Upload canceled");
    }
    throw error;
  }
};

export const cloneResourceColumn = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${cloneResourceColumnUrl}/${reqBody.resource_column_details_id}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResourceBackup = async ({ resourceId, page, pSize }: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    let requestUrl;
    if (resourceId && resourceId !== 0) {
      requestUrl = `${getResourceBackupUrl}?resource_backup_filter_ids=${resourceId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
export const getResourceColumnBackup = async ({
  resourceColumnId,
  page,
  pSize,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;

    let requestUrl;
    if (resourceColumnId && resourceColumnId !== 0) {
      requestUrl = `${getResourceColumnBackupUrl}?resource_column_backup_filter_ids=${resourceColumnId}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ValidateImportedResource = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${validateImportedResourceUrl}/${reqBody?.entity_description?.id}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const ValidateImportedResourceColumnDetails = async (reqBody: any) => {
  try {
    const response = await base.post(
      `${validateImportedResourceColumnDetailUrl}/${reqBody?.entity_description?.id}`,
      reqBody,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getResourceResultByResourceId = async ({
  currentResourceResultId,
}: any) => {
  try {
    let requestUrl;
    if (currentResourceResultId && currentResourceResultId !== 0) {
      requestUrl = `${getResourceResultByResourceIdUrl}/${currentResourceResultId}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getValidationsParams = async ({
  currentResourceResultId,
}: any) => {
  try {
    let requestUrl;
    if (currentResourceResultId && currentResourceResultId !== 0) {
      requestUrl = `${getValidationsParamsUrl}/${currentResourceResultId}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Validation Errors List
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationErrorsList = async ({
  currentValidationResultId,
  selectedColumnName,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  selectedColumnName: string;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsErrorsListByResultIdUrl}`;

    const params: URLSearchParams = new URLSearchParams();
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());
    if (currentValidationResultId)
      params.append("execution_id", currentValidationResultId.toString());
    if (selectedColumnName) params.append("name", selectedColumnName);

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Validation Duplicate Error List
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationDuplicateErrorsList = async ({
  currentValidationResultId,
  resourceId,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  resourceId: number;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsDuplicateErrorsListByResultIdUrl}`;

    const params: URLSearchParams = new URLSearchParams();
    if (currentValidationResultId)
      params.append("execution_id", currentValidationResultId.toString());
    if (resourceId) params.append("resource_id", resourceId.toString());
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Validation Cross Field List
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @param queryName
 * @returns
 */
export const getPaginatedValidationCrossFieldsList = async ({
  currentValidationResultId,
  page,
  pSize,
  queryName,
}: any) => {
  try {
    const pageN = page == null ? process.env.REACT_APP_DEFAULT_PAGE : page;
    const pageS =
      pSize == null ? process.env.REACT_APP_DEFAULT_PAGE_SIZE : pSize;
    let requestUrl;
    if (currentValidationResultId && currentValidationResultId !== 0) {
      requestUrl = `${getValidationsCrossFieldsListByResultIdUrl}/${currentValidationResultId}?name=${queryName}&page=${pageN}&size=${pageS}`;
    }
    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Validation Null keys
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationNullKeysList = async ({
  currentValidationResultId,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsNullKeysListByResultIdUrl}`;

    const params: URLSearchParams = new URLSearchParams();
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());
    if (currentValidationResultId)
      params.append("execution_id", currentValidationResultId.toString());

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Validation Errors List Without Issue
 * @param currentValidationResultId
 * @param selectedColumnName
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationErrorsListWithoutIssue = async ({
  currentValidationResultId,
  selectedColumnName,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  selectedColumnName: string;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsErrorsListByResultIdUrlWithoutIssue}/${currentValidationResultId}`;

    const params: URLSearchParams = new URLSearchParams();
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());
    if (selectedColumnName) params.append("name", selectedColumnName);

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Validation Duplicate Errors List Without Issue
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationDuplicateErrorsListWithoutIssue = async ({
  currentValidationResultId,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsDuplicateErrorsListByResultIdUrlWithoutIssue}/${currentValidationResultId}`;

    const params: URLSearchParams = new URLSearchParams();
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Validation Null Keys List Without Issue
 * @param currentValidationResultId
 * @param page
 * @param pSize
 * @returns
 */
export const getPaginatedValidationNullKeysListWithoutIssue = async ({
  currentValidationResultId,
  page,
  pSize,
}: {
  currentValidationResultId: number;
  page?: number;
  pSize?: number;
}) => {
  try {
    const pageN =
      page ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE || "1", 10);
    const pageS =
      pSize ?? parseInt(process.env.REACT_APP_DEFAULT_PAGE_SIZE || "25", 10);
    let requestUrl = `${getValidationsNullKeysListByResultIdUrlWithoutIssue}/${currentValidationResultId}`;

    const params: URLSearchParams = new URLSearchParams();
    if (pageN) params.append("page", pageN.toString());
    if (pageS) params.append("size", pageS.toString());

    requestUrl += `?${params.toString()}`;

    const response = await base.get(requestUrl);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Gets validation rerun result for a given execution ID
 * @param executionId - The ID of the execution to get results for
 * @returns The validation rerun result data
 * @throws Error if request fails
 */
export const getValidationRerunResultByExecutionId = async (
  executionId: number
 
): Promise<any> => {
  if (!executionId) {
    throw new Error("Execution ID is required");
  }

  const url = `${getValidationsParamsUrl}/${executionId}`;

  try {
    const response = await base.get(url);
    return response.data.complete_validation_params;
  } catch (error) {
    console.error("Failed to get validation rerun result:", error);
    throw error;
  }
};

export const deleteValidationExecutionbyID = async (
  currentExecutionId: any,
) => {
  try {
    const response = await base.delete(
      `${deleteResourceValidationbyIdUrl}/${currentExecutionId}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const abortValidationExecutionbyID = async (currentExecutionId: any) => {
  try {
    const response = await base.post(
      `${abortResourceValidationbyIdUrl}/${currentExecutionId}`,
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

//get used variables
export const getResourceUsedVariables = async (payload: any) => {
  try {
    const response = await base.post(`${getResourceUsedVariablesUrl}`, payload);
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

//get validation execution job status
export const getValidationExecutionJobStatus = async (executionId: number) => {
  try {
    const response = await base.get(
      `${getValidationExecutionJobStatusUrl}/${executionId}`,
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getResourceAuthTagDetails = async (resourceId: number) => {
  try {
    const response = await base.get(`${resourcesAuthTagUrl}/${resourceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching resource auth tag details:", error);
    throw error;
  }
};

export const validateEngineRequest = async (reqBody: any) => {
  try {
    const response = await base.post(validateRequestEngineUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error("Error validating engine request:", error);
    return Promise.reject(error);
  }
};

export const validateConfigRequest = async (reqBody: any) => {
  try {
    const response = await base.post(validateRequestUrl, reqBody);
    return response.data;
  } catch (error) {
    console.error("Error validating request:", error);
    return Promise.reject(error);
  }
};
